// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6025":"70fafd41","6999":"b90181b4","8758":"a5cb21f8"}[chunkId] + ".chunk.css";
};